<template>
  <div class="modalContainer">
    <div class="printContainer" ref="printHideDomRef" v-show="!isShowImg">
      <div class="titleContainer">
        <h1 class="mainTitle">汇款申请单</h1>
      </div>

      <table class="mainTable" border="1" cellspacing="0" cellpadding="0">
        <tr>
          <td style="width: 120px;" class="tdLabel">申请日期</td>
          <td>{{ this.ykDateFormat('yyyy-MM-dd', this.printData.apply_date) }}</td>
          <td style="width: 120px;" class="tdLabel">申请人</td>
          <td colspan="3">{{ this.printData.users_name }}</td>
        </tr>
        <tr>
          <td class="tdLabel">收款人名称</td>
          <td colspan="5">{{ this.printData.payee }}</td>
        </tr>

        <tr>
          <td class="tdLabel">开户行及账号</td>
          <td colspan="5">{{ this.printData.bank_account }}</td>
        </tr>

        <tr>
          <td class="tdLabel">金额(大写)</td>
          <td colspan="3">{{ this.amountLtoU(this.printData.amout) }}</td>
          <td colspan="2">￥:&emsp;{{ this.$utils.commafy(this.printData.amout, { digits: 2 }) }}</td>
        </tr>

        <tr>
          <td class="tdLabel">汇款事由</td>
          <td colspan="5">{{ this.printData.subject_matter }}</td>
        </tr>

        <!-- {{
              signHtml
            }} -->
        <tr v-if="this.printData.manager_review">
          <td class="tdLabel">单位主管</td>
          <td>
            <div class="signItems" v-html="lingongSign"></div>
          </td>
          <td class="tdLabel">汇出公司</td>
          <td colspan="3">{{ this.printData.remittance_company }}</td>
        </tr>

        <tr v-if="this.printData.manager_review">
          <td class="tdLabel">领导审批</td>
          <td>
            <div class="signItems" v-html="lingdaoSign"></div>
          </td>
          <td class="tdLabel">汇出日期</td>
          <td colspan="3">{{ this.ykDateFormat('yyyy-MM-dd', this.printData.remittance_date) }}</td>
        </tr>

        <tr v-if="this.printData.dept_name !== '软件'">
          <td rowspan="2" class="tdLabel">领导审批</td>
          <td rowspan="2">
            <div class="signItems" v-html="lingdaoSign"></div>
          </td>
          <td class="tdLabel">汇出公司</td>
          <td colspan="3">{{ this.printData.remittance_company }}</td>
        </tr>

        <tr v-if="this.printData.dept_name !== '软件'">
          <td class="tdLabel">汇出日期</td>
          <td colspan="3">{{ this.ykDateFormat('yyyy-MM-dd', this.printData.remittance_date) }}</td>
        </tr>

        <tr>
          <td class="tdLabel">备注</td>
          <td colspan="5">{{ this.printData.memo }}</td>
        </tr>
      </table>
    </div>

    <img id="printImgDom" style="cursor: pointer;width: 100%;" :src="imgSrc" @click="previewImg" v-show="isShowImg" />
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
// import SignObject from '../../public/utils/signJpg'
import { convertSign } from '../../public/utils/getSign'

export default {
  props: {
    printData: {
      type: Object
    }
  },
  data() {
    return {
      formVisible: false,
      imgSrc: '',
      // 打印签字
      lingdaoSign: '',
      lingongSign: '',
      signHtml: '',
      // 是否展示图片
      isShowImg: false
    }
  },
  methods: {
    // 预览图片
    previewImg() {
      this.$hevueImgPreview(this.imgSrc)
    },
    showModal() {
      this.handlePrint()
    },
    async handlePrint() {
      const { data: res } = await this.$http.get('/finance/users')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      const SignObject = convertSign(res.data)

      this.isShowImg = false

      this.lingdaoSign = ''

      this.lingongSign = ''

      this.signHtml = ``

      if (this.printData.manager_review && this.printData.document_status > 0) {
        this.lingongSign = `<img src="${SignObject['林源晟']}" />`
      }

      if (this.printData.document_status > 2) {
        this.lingdaoSign = `<img src="${SignObject['姚杨']}" />`
      }

      if (this.printData.manager_review) {
        this.signHtml = `
          <tr>
            <td class="tdLabel">单位主管</td>
            <td>
              <div class="signItems">
                ${this.lingongSign}
              </div>
            </td>
            <td class="tdLabel">汇出公司</td>
            <td colspan="3">${this.printData.remittance_company}</td>
          </tr>

          <tr>
            <td class="tdLabel">领导审批</td>
            <td>
              <div class="signItems">
                ${this.lingdaoSign}
              </div>
            </td>
            <td class="tdLabel">汇出日期</td>
            <td colspan="3">${this.ykDateFormat('yyyy-MM-dd', this.printData.remittance_date)}</td>
          </tr>
        `
      } else {
        this.signHtml = `
          <tr>
            <td rowspan="2" class="tdLabel">领导审批</td>
            <td rowspan="2">
              <div class="signItems">
                ${this.lingdaoSign}
              </div>
            </td>
            <td class="tdLabel">汇出公司</td>
            <td colspan="3">${this.printData.remittance_company}</td>
          </tr>

          <tr>
            <td class="tdLabel">汇出日期</td>
            <td colspan="3">${this.ykDateFormat('yyyy-MM-dd', this.printData.remittance_date)}</td>
          </tr>
        `
      }

      this.$nextTick(() => {
        html2canvas(this.$refs.printHideDomRef, {
          backgroundColor: null
        }).then(canvas => {
          let dataURL = canvas.toDataURL('image/png')

          // document.getElementById('printImgDom').src = dataURL
          this.imgSrc = dataURL

          this.isShowImg = true
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.modalContainer {
  width: 100%;

  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
}

/deep/ .printContainer {
  width: 774px;
  // height: 1103px;

  overflow: hidden;

  background-color: #fff;

  box-sizing: border-box;
  padding: 40px;
}

/deep/ .titleContainer {
  text-align: center;
}

/deep/ .titleContainer h1 {
  font-size: 30px;
  font-weight: 400;
}

/deep/ .footerContainer {
  display: flex;
  justify-content: space-around;
}

/deep/ .footerContainer div {
  width: 20%;
}

/deep/ .mainTable {
  width: 100%;
}

/deep/ table {
  /* text-align: center; */
  border-collapse: collapse;
  width: 100%;

  margin: 5px 0 15px 0;
}

/deep/ table td {
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #000000;

  height: 26px;

  font-size: 14px;
}

/deep/ .tdLabel {
  text-align: center;
}

/deep/ .signItems img {
  width: 80px;
}
</style>
